import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@rsos/components/capstone/base';
import { CRGSpatialLayerSelector } from '@rsos/components/capstone/common/Map/SpatialLayers/selectors';
import {
  showPopover,
  hidePopover,
} from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/mapPopoverSlice';
import StaticLayerGL from '@rsos/components/capstone/common/Map/useDeckGL/StaticLayersGL/StaticLayerGL';
import useDebounce from '@rsos/utils/useDebounce';
import {
  setActiveCRGObject,
  setActiveCRGObjectFloor,
} from '../../../../actions/spatialLayers';
import ExpandedMapDialog from '../../MapDialog/ExpandedMapDialog';

/**
 * CRG map handling using Deck.GL
 * @param {Object} overlay -
 * @param {removedID} removedID - Phone number of a call that was removed from the queue
 */
const CRGGL = ({ overlay, removedID, isMapIconDisabled }) => {
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  const dispatch = useDispatch();

  const CRGLayers = useSelector(state => {
    return CRGSpatialLayerSelector(state.spatialLayers.staticLayers) || [];
  });

  const activeCrgObject = useSelector(
    state => state.spatialLayers.activeCrgObject,
  );

  const handleMarkerClick = spatialObject => {
    dispatch(setActiveCRGObject(spatialObject));
    setActiveMarkerId(spatialObject.id);
  };

  const handleCloseCrgCard = () => {
    dispatch(setActiveCRGObject(null));
    dispatch(setActiveCRGObjectFloor(null));
    dispatch(hidePopover());
  };

  const isModalOpen = Object.keys(activeCrgObject.spatialObject).length > 0;
  useEffect(() => {
    if (!isModalOpen) {
      setActiveMarkerId(null);
    }
  }, [isModalOpen]);

  const handleMarkerHover = useDebounce(
    o => {
      if (o) {
        const pop = {
          spatialLayerKey: o.spatialObject?.external_id,
          spatialLayer: o.spatialLayer,
          spatialObject: o.spatialObject,
        };
        dispatch(showPopover(pop));
      } else {
        dispatch(hidePopover());
      }
    },
    100,
    [],
  );
  return (
    <>
      {CRGLayers.map((spatialLayer, i) => {
        return (
          <StaticLayerGL
            key={`${spatialLayer.id}-${i}`}
            overlay={overlay}
            spatialLayer={spatialLayer}
            onClick={handleMarkerClick}
            activeMarkerId={activeMarkerId}
            filled={false}
            onHover={handleMarkerHover}
            isMapIconDisabled={isMapIconDisabled}
          />
        );
      })}
      {isModalOpen && (
        <Modal
          id="expanded-map-dialog"
          onClose={handleCloseCrgCard}
          isOpened
          transparent
          disableBackdropClick
        >
          <ExpandedMapDialog
            onClose={handleCloseCrgCard}
            removedID={removedID}
          />
        </Modal>
      )}
    </>
  );
};

export default CRGGL;
